import { ItemData, ItemDataImageProps } from 'store/types'
import PostImagePlaceholder from 'molecules/post-items/image/PostImagePlaceholder'
import Image from 'atoms/Image'

type Props = {
  item: ItemData<'image'>
  onPropsChange: (props: ItemDataImageProps) => void
}

function PostImageTools({ item, onPropsChange }: Props) {
  return (
    <div className='flex flex-col gap-2'>
      <div>
        <div className='card bg-gray-100 border border-b-0 border-primary rounded-none rounded-t-btn overflow-hidden'>
          <div className='card-body items-center justify-center p-0'>
            {item.props.file && (
              <div className='badge badge-secondary absolute left-1 top-1'>
                {item.props.file.startsWith('https') ? 'cloud' : 'local'}
              </div>
            )}
            {item.props.file ? (
              <div className='p-4'>
                <Image src={item.props.file} width={200} height={200} />
              </div>
            ) : (
              <div className='w-full h-40 bg-white'>
                <PostImagePlaceholder />
              </div>
            )}
          </div>
        </div>
        <input
          type='file'
          className='file-input file-input-bordered file-input-primary w-full rounded-none rounded-b-btn cursor-pointer'
          onChange={e => {
            const file = e.target.files?.[0]
            if (!file) {
              onPropsChange({
                ...item.props,
                file: undefined
              })
              return
            }
            const reader = new FileReader()
            reader.onload = e => {
              onPropsChange({
                ...item.props,
                name: file.name,
                file: typeof e.target?.result === 'string' ? e.target.result : undefined
              })
            }
            reader.readAsDataURL(file)
          }}
        />
      </div>
    </div>
  )
}

export default PostImageTools
